"use strict";
/// <reference lib="WebWorker" />
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const cacheName = `${process.env.APP_NAME}-${process.env.APP_VERSION}`;
const staticAPI = String(process.env.API_STATIC_ENDPOINT);
console.log(cacheName);
const isLocalhost = Boolean(window.location.hostname === 'localhost' ||
    window.location.hostname === '[::1]' ||
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));
exports.default = () => {
    if ('serviceWorker' in navigator) {
        window.addEventListener('load', () => {
            const swUrl = '/sw.js';
            if (isLocalhost) {
                checkValidServiceWorker(swUrl);
                navigator.serviceWorker.ready.then(() => {
                    console.log('This web app is being served cache-first by a service ' +
                        'worker. To learn more, visit https://goo.gl/SC7cgQ');
                });
            }
            else {
                registerValidSW(swUrl);
            }
        });
        self.addEventListener('install', (event) => __awaiter(void 0, void 0, void 0, function* () {
            if (caches) {
                const kendoCSS = `${staticAPI}/css/kendo.css`;
                const kendoDarkCSS = `${staticAPI}/css/kendo-dark.css`;
                const names = yield caches.keys();
                names.forEach(name => {
                    event.waitUntil(caches.open(name).then(function (cache) {
                        return cache.addAll([kendoCSS, kendoDarkCSS]);
                    }));
                });
            }
        }));
        self.addEventListener('fetch', (event) => {
            event.respondWith(function () {
                return __awaiter(this, void 0, void 0, function* () {
                    const networkFetch = fetch(event.request);
                    // Try to get the response from a cache.
                    const cachedResponse = yield caches.match(event.request);
                    // Return it if found one.
                    if (cachedResponse) {
                        console.log('fetch', event.request, 'from cache');
                        return cachedResponse;
                    }
                    // If didn't find a match in the cache, use the network.
                    return networkFetch.then((response) => __awaiter(this, void 0, void 0, function* () {
                        const names = yield caches.keys();
                        names.forEach((name) => __awaiter(this, void 0, void 0, function* () {
                            const cache = yield caches.open(name);
                            cache.put(event.request, response.clone());
                        }));
                        return response;
                    }));
                });
            }());
        });
    }
};
const checkValidServiceWorker = (swUrl) => {
    if (process.env.NODE_ENV === 'development') {
        navigator.serviceWorker.ready.then(registration => {
            registration.unregister().then(() => {
                window.location.reload();
            });
        });
    }
    else {
        fetch(swUrl)
            .then((response) => {
            var _a;
            if (response.status === 404 ||
                ((_a = response.headers.get('content-type')) === null || _a === void 0 ? void 0 : _a.indexOf('javascript')) ===
                    -1) {
                navigator.serviceWorker.ready.then(registration => {
                    registration.unregister().then(() => {
                        window.location.reload();
                    });
                });
            }
            else {
                registerValidSW(swUrl);
            }
        })
            .catch((e) => {
            console.log(e);
        });
    }
};
const registerValidSW = (swUrl) => {
    navigator.serviceWorker
        .register(swUrl)
        .then((registration) => {
        registration.onupdatefound = () => {
            const installingWorker = registration.installing;
            if (installingWorker !== null) {
                installingWorker.onstatechange = () => {
                    if (installingWorker.state === 'installed') {
                        if (navigator.serviceWorker.controller) {
                            if (!isLocalhost) {
                                const isClearAllCaches = window.confirm(`Hoooraaay!!!, New update available for current version (${cacheName}). Click "Yes" to clear all caches (you must re login)`);
                                if (isClearAllCaches) {
                                    localStorage.clear();
                                }
                                console.log('New content is available; please refresh.');
                            }
                            window.location.reload();
                        }
                        else {
                            window.location.reload();
                            console.log('Content is cached for offline use.');
                        }
                    }
                };
            }
        };
    })
        .catch(error => {
        console.error('Error during service worker registration:', error);
    });
};
